import { Accordion, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { AttachmentView } from '../../../common/attachments/attachmentview'
import { actionTypeSelector } from '../../../reducers'

const actionPostTypes = {
	POST_DISCUSSION_SUCCEEDED: true,
	POST_DISCUSSION_EDIT_SUCCEEDED: true,
	POST_DISCUSSION_MODEL_SUCCEEDED: true,
	POST_DISCUSSION_MODEL_EDIT_SUCCEEDED: true,
}

export function DiscussionGroup5({ state }) {
	const { t } = useTranslation()
	const actionType = useSelector(actionTypeSelector)
	const path = window.location.pathname
	const isPersonal = path.startsWith('/personal')

	return (
		<Accordion defaultActiveKey={['discussionattachments']} flush alwaysOpen>
			<Accordion.Item key="discussionattachments" eventKey="discussionattachments">
				<Accordion.Header>{t('Attachments', 'Liitteet')}</Accordion.Header>
				<Accordion.Body>
					<Row>
						<AttachmentView
							section={state.personId > 0 ? 'discussion' : 'discussionmodel'}
							entityid={state.id}
							attachments={state.attachments}
							savedId={actionPostTypes[actionType] && state.id}
							readOnly={isPersonal}
							isPersonal={isPersonal}
						/>
					</Row>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	)
}
